import React, { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { pathArray } from "../utils/utils";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addRoute } from "../redux/features/candidate/candidateAuthSlice";

const FacialAuthenticationPrivateRoute = ({
  component: Component,
  ...rest
}) => {
  const dispatch = useDispatch();
  let examPlan = useSelector((state) => state.examDetail.examPlan);
  const { pathname } = useLocation();

  let currentPosition = pathArray.indexOf(pathname.substring(1));
  console.log("this is from the FacialAuthenticationPrivateRoute", {
    currentPosition,
    pathname,
    pathArray,
  });
  useEffect(() => {
    if (examPlan === "basic") {
      dispatch(addRoute(`/${pathArray[currentPosition + 1]}`));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [examPlan, dispatch]);

  return (
    <Route
      {...rest}
      render={({ props }) =>
        !(examPlan === "basic") ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={pathArray[currentPosition + 1]}
            from={pathArray[currentPosition - 1]}
          />
        )
      }
    />
  );
};

export default FacialAuthenticationPrivateRoute;
